var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminSidebarLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 494,
    height: 95,
    viewBox: "0 0 494 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2274_55580)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 494,
    height: 95,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.076 65.4742C319.265 73.8072 313.827 78.7221 305.77 78.7221C300.509 78.7221 295.838 76.687 292.62 71.5624C289.55 66.6674 289.858 55.5567 289.858 52.1554C289.858 52.1554 289.774 33.1934 290.381 30.8578C283.204 30.5602 276.47 30.3505 272.047 30.2314C271.407 33.0573 271.566 54.5845 271.566 54.5845H271.569C271.62 65.0263 272.369 74.4336 278.2 81.9873C284.44 90.0653 294.44 94.9971 305.74 94.9971C325.068 94.9971 337.391 81.7435 339.653 65.4713H321.076V65.4742Z",
    fill: "#006DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.569 23.7408C293.201 22.6552 296.559 16.2722 305.829 16.2722C312.728 16.2722 317.556 19.8974 319.972 26.0111C326.424 26.7622 333.05 27.7089 339.574 28.8994C337.179 12.9673 325.35 0 305.862 0C298.683 0 291.96 1.90754 287.367 4.84679C279.517 9.87216 275.374 15.8357 273.353 23.1257C277.853 23.1767 284.56 23.3241 292.569 23.7436",
    fill: "#006DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6339 9.66522C51.6876 3.35021 42.9934 0.739746 32.0794 0.739746H0V70.885C5.80923 68.5665 11.8114 66.3132 18.0092 64.1222V17.0063H31.7802C37.7209 17.0063 42.205 19.1122 45.0733 22.7884C48.5454 27.2384 48.8837 30.9996 48.8837 54.2302C54.7628 52.5296 66.9515 49.3012 66.9515 49.3012C66.9515 26.7735 66.9571 19.56 57.6339 9.66238",
    fill: "#006DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.915 53.927C176.077 51.2967 182.566 45.5401 184.853 36.5891C168.607 39.0834 143.576 43.4767 119.738 49.786V94.2234H137.722V56.94H150.674L168.658 94.2234H189.493L168.918 53.9299L168.915 53.927Z",
    fill: "#006DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.65 77.7585H219.076V55.2422H255.444V55.109H255.453V38.8793H219.076V32.4651C213.152 33.0065 207.156 33.6442 201.092 34.384V94.2263H261.782V77.9399H261.65V77.7614V77.7585Z",
    fill: "#006DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2928 94.2263C42.8649 94.2263 51.5452 91.4543 57.6339 85.2725C63.0294 79.805 65.3302 73.4758 66.2975 66.679C44.3493 74.9724 24.6656 84.2805 7.62646 94.2263H33.29H33.2928Z",
    fill: "#006DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5991 94.2233H101.583V54.8311C95.4524 56.6479 89.4587 58.5441 83.5991 60.5112V94.2205V94.2233Z",
    fill: "#006DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5991 45.2537C89.4699 43.9045 95.472 42.612 101.583 41.3677V0.782227H83.5991V45.2509V45.2537Z",
    fill: "#006DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.65 0.779541H201.092V26.5923C207.106 26.0282 213.108 25.5265 219.076 25.0985V17.0489H261.782V0.78521H261.65V0.779541Z",
    fill: "#006DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.464 94.2234H449.997L419.59 0.785156H438.211L456.729 61.6649L475.239 0.785156H494L463.464 94.2234Z",
    fill: "#006DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.655 17.0487V94.2233H368.663V17.0487H344.59V0.782227H410.722V17.0487H386.655Z",
    fill: "#006DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.719 17.0488H154.671C162.359 17.0488 167.749 21.5781 167.749 30.3534L185.7 28.1681C185.14 13.1033 174.12 0.776611 155.851 0.776611H119.735V37.873C125.675 36.7903 131.675 35.7529 137.719 34.7665V17.0488Z",
    fill: "#006DFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2274_55580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 494,
    height: 95,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminSidebarLogo);
export default __webpack_public_path__ + "static/media/admin_sidebar_logo.753278110ef1cfd37feeb2a1fb4caf82.svg";
export { ForwardRef as ReactComponent };